import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";

import { NgbPagination } from "@ng-bootstrap/ng-bootstrap";
import { FormsModule } from "@angular/forms";

@Component({
    selector: "pagination",
    templateUrl: "./pagination.component.html",
    styleUrls: ["./pagination.component.scss"],
    imports: [NgbPagination, FormsModule]
})
export class PaginationComponent implements OnChanges {

    @Input() numberOfRows!: number;
    @Input() currentPage!: number;
    @Input() rowsPerPage!: number;
    @Input() pagesVisible = 5;
    @Input() showFirstLastLink = true;
    @Input() showRowsPerPageAlt = true;
    @Input() rowsPerPageAlts: number[] = [10, 25, 50, 100];
    @Output() currentPageChange = new EventEmitter<number>();
    @Output() rowsPerPageChange = new EventEmitter<number>();


    ngOnChanges(changes: SimpleChanges) {
        // Om sidnumret hamnar utanför antal sidor efter sökning eller ändrat antal rader per sida,
        // Justera sidnumret till sista befintliga sidan 
        if (changes["numberOfRows"] || changes["rowsPerPage"]) {
            const lastPage = Math.max(1, Math.ceil(this.numberOfRows / this.rowsPerPage));
            if (this.currentPage > lastPage) {
                // Asynkront för att inte ändra förälderns värde mitt i change detection
                Promise.resolve().then(() => this.changePage(lastPage));
            }
        }
    }

    public changedRowsPerPage(rows: number) {
        this.rowsPerPage = Number(rows);
        this.rowsPerPageChange.emit(this.rowsPerPage);
        this.changePage(1);
    }

    private changePage(page: number) {
        this.currentPage = page;
        this.currentPageChange.emit(page);
    }
}
